<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"></app-admin-header>

<app-skelitions *ngIf="loading" [value]="3"></app-skelitions>

<ng-container *ngIf="!loading">
    <div class="color-dashboard">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
                <div class="d-flex flex-column">
                    <div class="d-flex my-2">
                        <label class="label-ui">{{'Organizational unit'|translator}}</label>
                    </div>
                    <div class="pos-rel">
                        <div class="theme-pos-abs">
                            <!-- <ng-container *ngIf="!selectedOu">
                                <img class="theme-pos-abs-img"
                                    src="https://img.freepik.com/free-vector/bird-colorful-logo-gradient-vector_343694-1365.jpg?semt=ais_hybrid&w=740"
                                    alt="loading">
                            </ng-container> -->
                            <ng-container *ngIf="selectedOu">
                                <img *ngIf="checkisImg(selectedOu.data); else elseBlock2"
                                    src="{{ staticURL }}{{ selectedOu.data }}" class="theme-pos-abs-img" />
                                <ng-template #elseBlock2>
                                    <i class="{{ selectedOu.data }} p-2" style="font-size: 1rem"></i>
                                </ng-template>
                            </ng-container>
                        </div>
                        <div class="d-flex gap-2">
                            <p-treeSelect class="v4-tree w-100" [options]="selectedTreeData" appendTo="body"
                                [(ngModel)]="selectedOu" (ngModelChange)="getOu()"
                                placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true"
                                [filterInputAutoFocus]="true">
                                <ng-template let-node pTemplate="default">
                                    <div class="d-flex">
                                        <img *ngIf="checkisImg(node.data); else elseBlock"
                                            src="{{ staticURL }}{{ node.data }}" class="img-fluid p-1 tree-img-bg"
                                            style="max-height: 30px; max-width: 30px" />
                                        <ng-template #elseBlock>
                                            <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                                        </ng-template>
                                        <b class="text-nowrap">{{ node.label }}</b>
                                    </div>
                                </ng-template>
                            </p-treeSelect>
                            <button *ngIf="selectedOu" 
                                class="theme-btn" 
                                pTooltip="{{'Clear Selection' | translator}}" 
                                tooltipPosition="top"
                                (click)="selectedOu = null; resetToDefault()">
                                <i class="pi pi-refresh"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="color-dashboard-white">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <label class="label-ui-2">{{'theme note'|translator}}</label>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="theme-btn" (click)="resetToDefault()">
                                <i class="fa-solid fa-rotate"></i>
                            </div>
                            <div *ngIf="selectedOu" class="theme-btn" (click)="submitThemeColors()">
                                <i class="fa-solid fa-check"></i>
                            </div>
                            <div *ngIf="!selectedOu" class="theme-btn" pTooltip="{{'Update Default Theme' | translator}}" tooltipPosition="top" (click)="submitThemeColors(true)">
                                <i class="pi pi-palette"></i>
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let group of themeColors; let gIndex = index">
                        <label class="label-ui-2">{{ group.heading | translator }}</label>
                        <div class="row px-2">
                            <div *ngFor="let variable of group.variables; let i = index" class="col-md-3 col-12 p-0">
                                <input class="color-picker" type="color"
                                    [(ngModel)]="selectedColors[getColorIndex(gIndex, i)]"
                                    (ngModelChange)="updateCssVariable(group.variables[i], $event)" [value]="" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
                <div class="d-flex my-2">
                    <label class="label-ui">{{'Inspection' | translator}}</label>
                </div>
                <div class="theme-navbar">
                    <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="my-2">
                            <img class="theme-logo" src="../../assets/new-logo/SCBCLOGO-WHITE.svg" alt="loading">
                        </div>
                        <div class="d-flex justify-content-center align-items-center gap-2 my-2">
                            <div class="theme-circle-2"></div>
                            <div class="theme-circle"></div>
                            <div class="theme-circle"></div>
                            <div class="theme-circle"></div>
                            <div class="theme-circle"></div>
                            <div class="theme-circle"></div>
                        </div>
                        <div class="d-flex gap-2 my-2">
                            <div class="theme-bell"></div>
                            <div class="">
                                <img class="theme-toggle" src="../../assets/v-4-icone/Frame7.png" alt="loading">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="theme-banner-bg">
                    <div class="banner-bredcrum">
                        <div class="theme-banner-pos-rel">
                            <div class="theme-banner">
                                <div class="pos-rel">
                                    <div class="d-flex justify-content-start align-items-center w-100">
                                        <div class="directory-v4">
                                            {{'test heading'| translator}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</ng-container>

<app-footer></app-footer>